import React from "react";
import cn from "classnames";
import { Button, Tooltip } from "antd";
import { FileWordOutlined, EditOutlined } from "@ant-design/icons";
import format from "@app/lib/format";
import { download } from "@app/lib/file";
import "./version-list-item.scoped.scss";

import versionAliasStore from "@app/state/store/report-document/version-alias";

const VersionListItem = ({
    menu,
    versionName,
    createdBy,
    aliasId,
    selectedAliasId,
    created,
    versionDate,
    index,
    fileId = null,
}) => {
    const onSelectVersionAlias = () => {
        versionAliasStore.onSelectVersionAlias(aliasId);
    };

    const onDownloadVersion = (e) => {
        e.stopPropagation();
        download(fileId, `${versionName}.docx`);
    };

    const onUpdateVersionAlias = (e) => {
        e.preventDefault();
        e.stopPropagation();
        versionAliasStore.onShowUpdateVersionAliasModal(aliasId);
    };

    return (
        <li className={cn("version-list-item", { selected: aliasId === selectedAliasId })}>
            <div className="container" onClick={onSelectVersionAlias}>
                <div className="version-title">
                    {versionName} - {format.date(versionDate)} {!index && "(latest)"}
                </div>
                <div>
                    Created by {createdBy.fullName} {format.datetime(created)}
                </div>
                <div className="button-container">
                    {fileId && (
                        <Tooltip title="Download this version" placement="topLeft">
                            <Button
                                className="download-button"
                                icon={<FileWordOutlined />}
                                onClick={onDownloadVersion}
                            />
                        </Tooltip>
                    )}
                    <Tooltip title="Rename this version" placement="topLeft">
                        <Button
                            className="edit-button"
                            icon={<EditOutlined />}
                            onClick={onUpdateVersionAlias}
                        />
                    </Tooltip>
                </div>
            </div>
        </li>
    );
};

export default VersionListItem;
